<template>
  <div class="container">
    <div class="homeView my-1">
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
        <div class="breadcrumbs">
          <div class="mb-1 d-flex flex-wrap align-items-center">
            <b-button v-if="showBack && historyBack" variant="outline-primary" size="sm"
              class="mr-2 d-flex align-items-center" @click="goBack">
              <feather-icon icon="ArrowLeftIcon" width="18px" height="18px" /> Quay lại
            </b-button>
            <ul class="breadcrumbs d-flex align-items-center pl-0 font-be-vietnam mb-0">
              <li style="padding-right: 10px;">
                <router-link :to="{ name: 'home' }">
                  <feather-icon icon="HomeIcon" width="18px" height="18px" />
                </router-link>
              </li>
              <template v-if="itemsData.category_list">
                <li v-for="(item, index) in itemsData.category_list" :key="index">
                  <router-link :title="item.name" :to="{ name: 'home-category', params: { slug: item.slug } }"
                    style=" color:#0B438D !important" class="font-weight-600">
                    {{ item.name }}
                  </router-link>
                </li>
              </template>
            </ul>
            <b-button v-if="showClose" variant="flat-danger" class="ml-auto" @click="goBack">
              <feather-icon icon="XIcon" width="18px" height="18px" />
            </b-button>
          </div>
        </div>
        <div class="row">
          <!-- CONTENT LEFT -->
          <div class="col-12 col-md-8">
            <div class="card shadow-none mb-1">
              <div id="printArticle" class="card-body p-1 mt-1 view font-be-vietnam"
                :class="itemsData.is_read ? '' : 'unselectable'"
                :oncontextmenu="itemsData.is_read ? 'return true' : 'return false'"
                :onselectstart="itemsData.is_read ? 'return true' : 'return false'">
                <h1 class="article-title font-weight-700 font-size32px lh-1-3 font-be-vietnam mb-0">
                  {{ itemsData.title }}
                </h1>
                <div class="article-date font-weight-500 font-size15px">
                  {{ itemsData.show_published_at }}
                </div>
                <div id="articleContent" class="article-detail detail mt-1" v-html="itemsData.content" />
              </div>
              <div v-if="Object.keys(itemsData).length > 0" class="reaction">
                <div v-if="donate.total > 0" class="reaction-head">
                  <span>{{ donate.total }} đã tặng</span>
                  <span v-if="donate.liked > 0"><i class="icon_like" /> {{ donate.liked }}</span>
                  <span v-if="donate.clap > 0"><i class="icon_clap" /> {{ donate.clap }}</span>
                  <span v-if="donate.star > 0"><i class="icon_star" /> {{ donate.star }}</span>
                  <span v-if="donate.heart > 0"><i class="icon_heart" /> {{ donate.heart }}</span>
                </div>
                <div class="donate">
                  <button class="btnReaction" type="button" @click="handlePopover"> {{ messageDonate(donate.donate_type)
                  }} </button>
                  <div v-if="popoverShow" class="reaction-body">
                    <button class="btnDonate" @click="handlDonate('liked')"><i class="icon_like" />Bổ ích</button>
                    <button class="btnDonate" @click="handlDonate('clap')"><i class="icon_clap" />Cảm hứng</button>
                    <button class="btnDonate" @click="handlDonate('star')"><i class="icon_star" />Độc đáo</button>
                    <button class="btnDonate" @click="handlDonate('heart')"><i class="icon_heart" />Xúc động</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Bình luận -->
            <comment v-if="itemsData" :article-id="itemsData.id" />
          </div>

          <!-- SIDEBAR RIGHT -->
          <div class="col-12 col-md-4">
            <div class="card author shadow-none sticky-top" :class="itemsData.is_read ? '' : 'unselectable'"
              :oncontextmenu="itemsData.is_read ? 'return true' : 'return false'"
              :onselectstart="itemsData.is_read ? 'return true' : 'return false'">
              <div class="card-body font-be-vietnam p-1">
                <div v-if="!itemsData.is_read" class="btnlink mt-1">
                  <button class="btn btn-sm btn-blue  w-100 font-weight-600 font-size15px font-be-vietnam"
                    @click="onReadArticle(itemsData.id)"><span class="iconFileDownloadWhite" /> <span>Lấy
                      tin</span></button>
                </div>
                <div v-else class="d-flex flex-row mt-1">
                  <button type="button" class="btn btn-sm btn-blue  w-30 font-weight-600 font-size15px font-be-vietnam"
                    @click="doCopy"><span class="iconCopySimple" /> Copy</button>
                  <button
                    class="btn btn-sm w-40 ml-1 pl-5px pr-5px d-flex font-weight-600 font-size15px font-be-vietnam btn_boder align-items-center"
                    title="Tải media" :disabled="disabledDowloadAll" @click="downloadAll(itemsData)"><span
                      class="iconFileDownload" /> Tải media</button>
                  <button
                    class="btn btn-sm  d-flex  ml-1  font-weight-600 font-size15px font-be-vietnam btn_boder align-items-center"
                    :class="itemsData.is_bookmark === 1 ? 'text-warning' : ''" @click="doBookmark(itemsData.id)">
                    <feather-icon icon="BookmarkIcon" width="18px" height="18px" />
                  </button>
                  <button v-print="'#printArticle'"
                    class="btn btn-sm  d-flex  ml-1  font-weight-600 font-size15px font-be-vietnam btn_boder align-items-center"><span
                      class="iconPrintSimple" /></button>
                  <button
                    class="btn btn-sm ml-1 mr-1   d-flex font-weight-600 font-size15px font-be-vietnam btn_boder align-items-center"
                    @click="export2Word(itemsData)"><span class="icon_file_doc" /></button>
                </div>
                <hr class="hr_boder">
                <ul>
                  <li>
                    <p class="font-be-vietnam text-dark-2 font-weight-700">
                      Khai thác:
                    </p>
                    <ul class="pl-10px">
                      <li class="text-dark-2 font-be-vietnam d-flex">
                        <div class="w-50 font-weight-500">
                          <span class="font-weight-500 text-dark-2">Lượt xem: </span> <span
                            class="font-weight-700 text-dark">{{ itemsData.views }}</span>
                        </div>
                        <span class="pr-1" style="color:#E8E8E8"> | </span>
                        <div class="w-50 font-weight-500">
                          <span class="font-weight-500 text-dark-2">Lượt lấy: </span> <span
                            class="font-weight-700 text-dark"> {{ itemsData.count_get_article }}</span>
                        </div>
                      </li>
                      <li class=" font-be-vietnam">
                        <span class="text-dark-2 font-weight-500">Đơn vị lấy tin: </span><span class="font-weight-700">{{
                          itemsData.unit }} </span>
                      </li>
                      <li class="text-dark-2 font-be-vietnam">
                        <span class="text-dark-2 font-weight-500">Phòng lấy tin:</span> <span class="font-weight-700">{{
                          itemsData.depart_read }}</span>
                      </li>
                    </ul>
                  </li>
                  <hr>
                  <li>
                    <p class="font-be-vietnam text-dark-2 font-weight-700">
                      Sản xuất:
                    </p>
                    <ul class="pl-10px">
                      <li class="text-dark-2 font-be-vietnam">
                        <span class="text-dark-2 font-weight-500"> Đơn vị làm tin:</span> <span class="font-weight-700">{{
                          author ? author.unit : '' }}</span>
                      </li>
                      <li class="text-dark-2 font-be-vietnam">
                        <span class="text-dark-2 font-weight-500"> Tác giả:</span> <span class="font-weight-700">{{
                          renderAuthor(coAuthor, author) }}</span>
                      </li>
                      <li v-if="dataApproved" class="text-dark-2 font-be-vietnam"> <span
                          class="text-dark-2 font-weight-500"> Phê duyệt:</span> <span class="font-weight-700">{{
                            dataApproved ? (dataApproved.alias ? dataApproved.alias : dataApproved.full_name) :
                            '' }}</span>
                      </li>
                      <li v-if="dataCorrected" class="text-dark-2 font-be-vietnam"> <span
                          class="text-dark-2 font-weight-500">Duyệt xuất bản:</span> <span class="font-weight-700">{{
                            dataCorrected ? (dataCorrected.alias ? dataCorrected.alias :
                              dataCorrected.full_name) : '' }}</span>
                      </li>
                    </ul>
                  </li>
                  <hr v-if="content_files.length > 0" class="hr_boder">
                  <li v-if="content_files.length > 0" class="file d-flex flex-column">
                    <p class="mb-0 font-be-vietnam text-dark-2 font-weight-700">
                      File media
                    </p>
                    <a v-for="(file, index) in content_files" :key="index"
                      :href="checkMineType(file) ? (file.file_path ? file.file_path : file) : 'javascript:void(0)'"
                      :data_type="checkMineType(file) ? 'doc' : 'mp3'" @click="dowload(file)"> {{
                        renderFileNameMedia(file) }} </a>
                  </li>
                  <hr>
                  <li class="file d-flex flex-column">
                    <p class="mb-0 font-be-vietnam text-dark-2 font-weight-700">
                      Dữ liệu gốc
                    </p>
                    <!-- <p v-for="(file, index) in attached_files" :key="index">
                      <a  :href="checkMineType(file) ? (file.file_path ? file.file_path : file) : 'javascript:void(0)'"
                      @click="dowload(file)"> {{ file.name }}.{{ file.extension }} </a>
                    </p> -->

                    <p v-for="(file, index) in attached_files" :key="index" class="mb-0">
                      <a :href="file.full_path ? file.full_path : file.file_path" target="_blank" v-if="checkType(file)">
                        {{ file.name }}.{{ file.extension }}
                      </a>
                      <a href="javascript:void(0)" @click="onPreviewFile(file)" v-else> {{
                        file.name }}.{{ file.extension }} </a>
                      <button type="button" class="btnDownload2" @click="dowload(file)">
                        <feather-icon icon="DownloadIcon" size="18" />
                      </button>
                    </p>
                  </li>
                </ul>
                <hr v-if="tags.length > 0">
                <div v-if="tags.length > 0" class="tags mt-1">
                  <p class="mb-0 font-weight-600 font-size15px font-be-vietnam" style="color: #868a9d;"> Từ khóa </p>
                  <ul class="text-wrap">
                    <li v-for="(tag, index) in tags" :key="index">
                      <a href="#" :title="tag">{{ tag }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row relate">
          <div v-if="dataRelate.length" class="col-12 col-md-6"
            :class="dataRelate.length && dataRelateNews.length ? 'col-md-6' : 'col-md-12'">
            <div class="card shadow-none">
              <div class="card-header">
                <h3 class="card-title text-uppercase fw-bolder font-be-vietnam">
                  Tin cùng chuyên mục
                </h3>
              </div>
              <div class="card-body p-1">
                <ul class="new-list">
                  <li v-for="(item, index) in dataRelate" :key="index">
                    <h3 class="news-title">
                      <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }"
                        class="link font-be-vietnam">
                        <span :class="renderClassTitleView(item)">
                          {{ item.title }}
                          <span v-if="item.hot" class="iconHotGif" />
                          <span v-if="item.is_get" class="iconNewsRead" />
                        </span> </router-link>
                    </h3>
                    <div class="news-icon d-flex flex-row">
                      <span v-for=" (type, key) in item.content_type" :key="key" class=" mr-0">
                        <span v-if="type === 'audio'" class="iconAudioBlue" />
                        <span v-if="type === 'photo'" class="iconPhotoBlue" />
                        <span v-if="type === 'video'" class="iconVideoBlue" />
                      </span>
                      <span class="icon font-be-vietnam ml-auto ml-auto">{{ timeago(item.published_at) }}</span>
                      <span v-if="item.unit" class=" icon pl-10px" />
                      <span v-if="item.unit">{{ item.unit }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="dataRelateNews.length" class="col-12 "
            :class="dataRelate.length && dataRelateNews.length ? 'col-md-6' : 'col-md-12'">
            <div class="card shadow-none">
              <div class="card-header">
                <h3 class="card-title text-uppercase fw-bolder font-be-vietnam">
                  Tin liên quan
                </h3>
              </div>
              <div class="card-body p-1">
                <ul class="new-list">
                  <li v-for="(item, index) in dataRelateNews" :key="index">
                    <h3 class="news-title">
                      <router-link :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }"
                        class="link font-be-vietnam">
                        <span :class="renderClassTitleView(item)">{{ item.title }}
                          <span v-if="item.hot" class="iconHotGif" />
                          <span v-if="item.is_get" class="iconNewsRead" />
                        </span> </router-link>
                    </h3>
                    <div class="news-icon d-flex flex-row">
                      <span v-for=" (type, key) in item.content_type" :key="key" class="mr-0">
                        <span v-if="type === 'audio'" class="iconAudioBlue" />
                        <span v-if="type === 'photo'" class="iconPhotoBlue" />
                        <span v-if="type === 'video'" class="iconVideoBlue" />
                      </span>
                      <span class="icon font-be-vietnam ml-auto">{{ timeago(item.published_at) }}</span>
                      <span v-if="item.unit" class=" icon pl-10px" />
                      <span v-if="item.unit">{{ item.unit }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- CLOSE ON BOTTOM -->
        <div v-if="showClose" class="text-center my-1">
          <b-button variant="outline-danger" class="ml-auto" @click="goBack">
            <feather-icon icon="XIcon" width="18px" height="18px" /> Đóng lại
          </b-button>
        </div>
        <b-modal id="filePreview" body-class="p-0 mb-2" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop
          hide-footer title="Xem trước">
          <preview-file :itemFile="itemFile" />
        </b-modal>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import {
  BOverlay,
  BButton,

} from 'bootstrap-vue';
import {
  watch, onMounted,
} from '@vue/composition-api';

import moment from 'moment';
import print from 'vue-print-nb'
import '@/libs/func'
import { useRouter } from '@core/utils/utils';
import Comment from './partials/Comment.vue';
import useView from './useView'
import PreviewFile from "./components/PreviewFile.vue"

export default {
  components: {
    BOverlay,
    BButton,
    Comment,
    PreviewFile
  },
  directives: {
    print,
  },
  props: {
    articleId: {
      type: Number,
      default: 0,
    },
    showRelate: {
      type: Boolean,
      default: true,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataParent: [],
      moment,
      itemFile: {}
    }
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = props.articleId || route.value.params.id;
    const historyBack = (!props.articleId && window.history.length > 1) || props.articleId;
    const goBack = () => {
      if (props.articleId) {
        context.emit('close-modal')
      } else {
        window.history.go(-1);
      }
    }
    const {
      loadHtml,
      fetchData,
      fechDataRelated,
      itemsData,
      loading,
      total,
      dataRelate,
      attached_files,
      tags,
      author,
      coAuthor,
      dataCorrected,
      dataApproved,
      content_files,
      all_file,
      Imgsize,
      disabledDowloadAll,
      dataRelateNews,
      donate,
      donate_title,
      donate_message,
      article_id,
      documentMimetypes,
      checkMineType,
      makeSlug,
      renderClassTitleView,
      renderPartOrUnit,
      renderFileNameMedia,
      export2Word,
      doBookmark,
      plusDonate,
      minusDonate,
      messageDonate,
      onReadArticle,
      onWindowScroll,
      handlePopover,
      handlDonate,
      renderAuthor,
      dowload,
      downloadItem,
      downloadAll,
      timeago,
      iconView,
      doCopy,
      popoverShow,
    } = useView(context);

    fetchData(id)

    onMounted(() => {
      onWindowScroll()
    });

    if (props.showRelate) {
      fechDataRelated(id)
    }
    if (!props.articleId) {
      watch(
        () => route.value.params.id,
        (newId, oldId) => {
          fetchData(newId)
        },
      )
    }

    const checkType = (file) => {
      let arr = file.mimetype.split('/');
      if (arr[0] == 'application' || file.type == 'document') {
        return true
      }
      return false
    }

    return {
      loadHtml,
      fetchData,
      fechDataRelated,
      itemsData,
      loading,
      total,
      dataRelate,
      attached_files,
      tags,
      author,
      coAuthor,
      dataCorrected,
      dataApproved,
      content_files,
      all_file,
      Imgsize,
      disabledDowloadAll,
      dataRelateNews,
      donate,
      donate_title,
      donate_message,
      article_id,
      documentMimetypes,
      checkMineType,
      makeSlug,
      renderClassTitleView,
      renderPartOrUnit,
      renderFileNameMedia,
      export2Word,
      doBookmark,
      plusDonate,
      minusDonate,
      messageDonate,
      onReadArticle,
      onWindowScroll,
      handlePopover,
      handlDonate,
      renderAuthor,
      dowload,
      downloadItem,
      downloadAll,
      timeago,
      iconView,
      doCopy,
      popoverShow,
      goBack,
      historyBack,
      checkType
    }
  },
  methods: {
    onPreviewFile(item) {
      this.itemFile = item
      this.$bvModal.show('filePreview');
    },
  },
}
</script>
<style lang="scss"></style>
